var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingEventIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 24.5418H25.75M19.5625 1.85432C20.1095 1.30731 20.8514 1 21.625 1C22.008 1 22.3873 1.07545 22.7412 1.22203C23.0951 1.36861 23.4166 1.58346 23.6875 1.85432C23.9584 2.12517 24.1732 2.44671 24.3198 2.8006C24.4664 3.15448 24.5418 3.53377 24.5418 3.91682C24.5418 4.29986 24.4664 4.67915 24.3198 5.03303C24.1732 5.38692 23.9584 5.70846 23.6875 5.97932L6.5 23.1668L1 24.5418L2.375 19.0418L19.5625 1.85432Z",
    stroke: "#CC4A57",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEventIcon);
export default __webpack_public_path__ + "static/media/upcoming-event-icon.6c9f7c240b478f5070d83ab4292782a1.svg";
export { ForwardRef as ReactComponent };